import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useI18n } from "@/i18n/I18nProvider";

// Simple centered shell for forgot/reset/forced-change password screens.
export const AuthCard = ({ title, subtitle, children, testId, footer }) => {
  const { t } = useI18n();
  return (
    <div className="flex min-h-[100dvh] flex-col bg-[#F8FAFC] px-5 py-6 sm:px-10">
      <div className="flex justify-end"><LanguageToggle testIdPrefix={`${testId}-lang`} /></div>
      <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-10">
        <div className="mb-8 flex justify-center"><Logo size="lg" testId={`${testId}-logo`} className="rounded-xl shadow-md" /></div>
        <h1 data-testid={`${testId}-title`} className="font-display text-2xl font-extrabold tracking-tight text-[#000B45] sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-gray-600">{subtitle}</p>}
        <div className="mt-8">{children}</div>
        {footer !== undefined ? footer : (
          <Link to="/login" data-testid={`${testId}-back-login`}
            className="mt-6 self-center rounded px-2 py-2 text-sm font-semibold text-[#000B45] underline-offset-4 hover:underline">
            {t("auth.backToLogin")}
          </Link>
        )}
      </div>
    </div>
  );
};

export const PrimaryButton = ({ busy, children, testId }) => (
  <button type="submit" disabled={busy} data-testid={testId}
    className="flex h-12 w-full items-center justify-center gap-2 rounded-lg bg-[#000B45] text-base font-bold text-white transition-colors hover:bg-[#000624] disabled:opacity-70">
    {children}
  </button>
);
